import ROUTE_NAMES from '@/app/admin/router/router-const'
export default [
  {
    path: 'reserved',
    name: ROUTE_NAMES.RESERVED,
    component: () => import('../ReservedPage.vue'),
  }
]